import { render, staticRenderFns } from "./CollaboratorOffline.vue?vue&type=template&id=dc8cda1e"
import script from "./CollaboratorOffline.vue?vue&type=script&lang=js"
export * from "./CollaboratorOffline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports